import Vue from "vue";
import "./assets/css/font.scss";
// 数据可视化 组件
import dataV from "@jiaminghi/data-view";
// 视频插件
import "video.js/dist/video-js.css";
import VideoPlayer from "vue-video-player";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import Vue2OrgTree from "vue2-org-tree";
import tween from "./utils/tween";
Vue.use(tween);
Vue.use(Vue2OrgTree);
Vue.use(dataV);
Vue.use(VideoPlayer);
Vue.use(ElementUI);
Vue.config.productionTip = false;
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
